'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _scriptjs = require('scriptjs');

var _scriptjs2 = _interopRequireDefault(_scriptjs);

var _authClientComponent = require('@wh/auth-client-component');

var _authClientComponent2 = _interopRequireDefault(_authClientComponent);

var _uiComponents = require('@wh/ui-components');

var _logo = require('../logo');

var _logo2 = _interopRequireDefault(_logo);

var _loginForm = require('../login-form');

var _loginForm2 = _interopRequireDefault(_loginForm);

var _message = require('../message');

var _message2 = _interopRequireDefault(_message);

var _register = require('../register');

var _register2 = _interopRequireDefault(_register);

var _constants = require('./../constants');

require('./login-component.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var componentMethodToCalls = {
    CALL_DISPLAY_LOGIN_FORM: _constants.CALL_DISPLAY_LOGIN_FORM,
    CALL_DISPLAY_MESSAGE: _constants.CALL_DISPLAY_MESSAGE
};
var componentsToDisplay = {
    NO_ELEMENT: _constants.NO_ELEMENT,
    MESSAGE_ELEMENT: _constants.MESSAGE_ELEMENT,
    LOGIN_FORM_ELEMENT: _constants.LOGIN_FORM_ELEMENT
};

var _ref = (0, _jsx3.default)(_uiComponents.Spinner, {
    className: 'login-component__spinner'
});

var _ref2 = (0, _jsx3.default)(_logo2.default, {});

/**
 * Login Form Modal component
 * @returns {Element} React element
 */
var LoginComponent = function (_Component) {
    (0, _inherits3.default)(LoginComponent, _Component);

    function LoginComponent(props, context) {
        var _this$componentMethod;

        (0, _classCallCheck3.default)(this, LoginComponent);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LoginComponent.__proto__ || (0, _getPrototypeOf2.default)(LoginComponent)).call(this, props, context));

        _this.componentMethodToCallMap = (_this$componentMethod = {}, (0, _defineProperty3.default)(_this$componentMethod, _constants.CALL_DISPLAY_LOGIN_FORM, _this.displayLoginForm), (0, _defineProperty3.default)(_this$componentMethod, _constants.CALL_DISPLAY_MESSAGE, _this.displayMessage), _this$componentMethod);


        _this.state = {
            contentElementName: _constants.NO_ELEMENT
        };

        _this.casClient = new _authClientComponent2.default(_this.props.casUrl, _this.props.service);
        // Defining accepted language as ql forces CAS to provide message codes instead of messages.
        _this.casClient.setAcceptedLanguage('ql');
        // TODO: (LC-116) Think about better solution...
        global.WH = global.WH || {};
        global.WH.casClient = global.WH.casClient || _this.casClient;
        return _this;
    }

    (0, _createClass3.default)(LoginComponent, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            // script is used to open links like this: "javascript:rn.showHelp('ANSWER', 2733);"
            // such links are used in error messages which come from translations keys from squiz
            (0, _scriptjs2.default)('https://williamhill-lang.custhelp.com/euf/assets/js/rn_cp_scripts.js');
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.initForm(this.casClient);

            // TODO: pass loginButtonLocation somehow
            this.props.trackingEvent(_constants.TRACKING_EVENT_NAME_LOGIN_OPENED, {
                loginLaunchLocation: this.props.service,
                loginButtonLocation: this.loginButtonLocation
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var method = nextProps.componentMethodToCall;
            if (method && this.componentMethodToCallMap[method] && method !== this.props.componentMethodToCall) {
                this.componentMethodToCallMap[method].call(this, nextProps);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.trackingEvent(_constants.TRACKING_EVENT_NAME_LOGIN_CLOSED);
            this.props.clearProps();
        }

        /**
         * A map from componentMethodToCall to method to call
         * @type {ActionToReducerMapType}
         */

    }, {
        key: 'displayLoginForm',
        value: function displayLoginForm() {
            if (this.props.componentMethodToCall === _constants.CALL_DISPLAY_MESSAGE) return;

            this.setState({
                contentElementName: _constants.LOGIN_FORM_ELEMENT
            });
        }
    }, {
        key: 'displayMessage',
        value: function displayMessage() {
            this.setState({
                contentElementName: _constants.MESSAGE_ELEMENT
            });
        }
    }, {
        key: 'selectContent',
        value: function selectContent() {
            var _props = this.props,
                title = _props.title,
                text = _props.text,
                placeholders = _props.placeholders;
            var contentElementName = this.state.contentElementName;


            switch (contentElementName) {
                case _constants.MESSAGE_ELEMENT:
                    return (0, _jsx3.default)(_message2.default, {
                        title: title,
                        text: text,
                        placeholders: placeholders,
                        className: 'c-login-form__message'
                    });

                case _constants.LOGIN_FORM_ELEMENT:
                    return (0, _jsx3.default)('div', {}, void 0, text && (0, _jsx3.default)(_message2.default, {
                        title: title,
                        text: text,
                        placeholders: placeholders,
                        className: 'c-login-form__login-error'
                    }), (0, _jsx3.default)(_loginForm2.default, {
                        casClient: this.casClient
                    }));

                default:
                    return null;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                isFetching = _props2.isFetching,
                registrationClicked = _props2.registrationClicked,
                className = _props2.className;

            var contentElement = isFetching ? _ref : this.selectContent();
            var loginClassNames = (0, _classnames2.default)('login-component__wrapper', className);

            return (0, _jsx3.default)('div', {
                className: loginClassNames
            }, void 0, (0, _jsx3.default)(_register2.default, {
                onClick: registrationClicked
            }), _ref2, contentElement);
        }
    }]);
    return LoginComponent;
}(_react.Component);

LoginComponent.defaultProps = {
    casUrl: '',
    service: '',
    className: '',
    initForm: function initForm() {},
    clearProps: function clearProps() {},
    registrationClicked: function registrationClicked() {},
    trackingEvent: function trackingEvent() {}
};
exports.default = LoginComponent;
//# sourceMappingURL=login-component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/login-component/login-component.js
// module id = 487
// module chunks = 0